import { Calendar, Search, FileX } from "lucide-react";
import { cn } from "../../../lib/utils";

interface EmptyStateProps {
  type: "no-appointments" | "no-results" | "error";
  className?: string;
}

const emptyStateConfig = {
  "no-appointments": {
    icon: Calendar,
    title: "Không có lịch hẹn",
    description: "Chưa có lịch hẹn nào được đặt trong khoảng thời gian này.",
  },
  "no-results": {
    icon: Search,
    title: "Không tìm thấy kết quả",
    description: "Không có cuộc hẹn phù hợp với từ khóa tìm kiếm. Hãy thử lại với từ khóa khác.",
  },
  "error": {
    icon: FileX,
    title: "Đã có lỗi xảy ra",
    description: "Không thể tải dữ liệu. Vui lòng thử lại sau.",
  },
};

export function EmptyState({ type, className }: EmptyStateProps) {
  const config = emptyStateConfig[type];
  const Icon = config.icon;

  return (
    <div
      className={cn(
        "flex flex-col items-center justify-center py-16 px-4 text-center",
        className
      )}
      data-testid={`empty-state-${type}`}
    >
      <div className="rounded-full bg-muted p-4 mb-4">
        <Icon className="h-8 w-8 text-muted-foreground" />
      </div>
      <h3 className="text-lg font-semibold text-foreground mb-2">
        {config.title}
      </h3>
      <p className="text-sm text-muted-foreground max-w-sm">
        {config.description}
      </p>
    </div>
  );
}
